<template>
  <div>
    <el-carousel height="100vh">
      <el-carousel-item v-for="item in bannerList" :key="item.url">
        <img :src="item.url" alt="">
        <div class="content">
          <img :src="item['title-img']" alt="">
<!--          <h3 class="small">{{ item.title }}</h3>-->
<!--          <p class="sub-title" v-html="item['sub-title']"></p>-->
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-button class="go-next" type="text" @click.stop="goNext">
      进入 <i class="el-icon-right"></i>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      bannerList: this.$store.state.page.pageConfig['轮播页']
    }
  },
  props: [],
  methods: {
    goNext () {
      // eslint-disable-next-line no-undef
      window.impress().next()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";
.el-carousel {
  width: 100vw;
  height: 100vh;
  position: relative;
  img {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
  .content {
    position: absolute;
    left: 10%;
    top: 20%;
    z-index: 11;
    img{
      width: unset;
      height: 360px;
    }
    h3{
      height: 100px;
      font-size: 55px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 100px;
    }
    .sub-title{
      font-size: 45px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 65px;
    }
  }
}
</style>
